import React, { Fragment } from "react";
import {
  Page,
  Navbar,
  NavTitle,
  Block,
  Card,
  CardContent,
  CardHeader,
  Row,
  Col,
  Button,
  Badge,
} from "framework7-react";

import { compose } from "redux";
import { connect } from "react-redux";
import { withFirestore } from "../HOCs";
import { LOAD_MANAGED_BRANCHES } from "../store/actions/firestore";
import { toast, handleErrors } from "../utils/_helpers";

class BranchDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      managedBranchesUnsub: null,
      pendingBranchesOrders: null,
      subscriptions: null,
    };
  }

  render() {
    return (
      <Page
        id="branch-dashboard-page"
        // onPageBeforeRemove={() => {
        //   if (this.state.managedBranchesUnsub) {
        //     this.state.managedBranchesUnsub();
        //   }

        //   if (this.state.subscriptions) {
        //     for (const unsub of this.state.subscriptions) {
        //       unsub();
        //     }
        //   }
        // }}
      >
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding>Branch Dashboard</NavTitle>
        </Navbar>
        <Block className="pattern-banner bg-color-oldlace">
          <Card className="elevation-1" style={{ width: "100%", margin: 0 }}>
            <CardHeader>
              <h3 style={{ margin: 0 }}>Branches You Manage</h3>
            </CardHeader>
          </Card>
        </Block>
        <Block>
          {/* load all the branches the user manages */}
          {this.props?.managedBranches?.delivery
            .sort(
              (a, b) =>
                this.state.pendingBranchesOrders?.[b.id] -
                this.state.pendingBranchesOrders?.[a.id],
            )
            .map(({ id, headquatersName, name, city }) => (
              <Card className="rounded m-0 mt-20 elevation-2" key={id}>
                <CardContent>
                  <Row>
                    <Col width={70} medium={85}>
                      <h3 className="font-medium sans-serif m-0 text-ellipsis">
                        {headquatersName} - {name}
                      </h3>
                      <small>{city}</small>
                    </Col>
                    <Col width={30} medium={15}>
                      <Button
                        fill
                        href={`/branch-delivery/${id}/`}
                        className="flex justify-around items-center"
                      >
                        View
                        {this.state.pendingBranchesOrders?.[id] > 0 && (
                          <Badge color="red">
                            {this.state.pendingBranchesOrders?.[id]}
                          </Badge>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </CardContent>
              </Card>
            ))}
        </Block>
      </Page>
    );
  }

  async componentDidMount() {
    this.setState({
      ...this.state,
      managedBranchesUnsub: this.props.firestore
        .collectionGroup("branches")
        .where("managersIds", "array-contains", this.props.auth.uid)
        .onSnapshot(
          (snapshot) => {
            if (!snapshot.empty) {
              const managedBranches = [];
              snapshot.docs.forEach((doc) => {
                managedBranches.push({
                  id: doc.id,
                  ...doc.data(),
                });
              });

              this.props.dispatch({
                type: LOAD_MANAGED_BRANCHES,
                payload: {
                  data: managedBranches,
                },
              });
            } else {
              this.props.dispatch({
                type: LOAD_MANAGED_BRANCHES,
                payload: {
                  data: [],
                },
              });
            }
          },
          (error) => {
            console.log(error);
            toast(this.$f7.toast, {
              text: "Unable to fetch managed branches, please reload page.",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          },
        ),
    });

    if (this.props.managedBranches?.delivery.length) {
      const subscriptions = await this.getPendingOrders();
      this.setState({
        ...this.state,
        subscriptions,
      });
    }
  }

  componentWillUnmount() {
    if (this.state.managedBranchesUnsub) {
      this.state.managedBranchesUnsub();
    }

    if (this.state.subscriptions) {
      for (const unsub of this.state.subscriptions) {
        unsub();
      }
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.managedBranches?.delivery.length !==
      this.props.managedBranches?.delivery.length
    ) {
      if (this.state.subscriptions) {
        for (const unsub of this.state.subscriptions) {
          unsub();
        }
      }

      const subscriptions = await this.getPendingOrders();
      this.setState({
        ...this.state,
        subscriptions,
      });
    }
  }

  async getPendingOrders() {
    const promises = [];

    for (const branch of this.props.managedBranches.delivery) {
      const q = this.props.firestore
        .collection("orders")
        .where("agent.branch.id", "==", branch.id)
        .where("orderStatus", "==", "Order Pending Delivery");
      promises.push(
        q.onSnapshot(
          (snapshot) => {
            this.setState({
              ...this.state,
              pendingBranchesOrders: {
                ...this.state.pendingBranchesOrders,
                [branch.id]: snapshot.size,
              },
            });
          },
          (error) => {
            toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          },
        ),
      );
    }

    return promises;
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: {
    docs: { managedBranches },
  },
}) => ({
  auth,
  profile,
  managedBranches: (managedBranches && managedBranches) || null,
});

const enhance = compose(withFirestore, connect(mapStateToProps));

export default enhance(BranchDashboard);
